import { Button } from "@datamole/wds-component-button";
import { Card } from "@datamole/wds-component-card";
import { faMapPin, faLink, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";

import styles from "./entity-card.module.css";

import { InfoPopoverContext, NavPointTrigger } from "@/features/info-popover/popover.context";
import { navPoints } from "@/features/storage/data-provider";
import { storageService } from "@/features/storage/storage.service";

type Props = {
    trigger: NavPointTrigger;
};

export const NavPointHeader = ({ trigger }: Props) => {
    const point = navPoints.find((p) => p.id === trigger.pointId);
    if (!point) return null;

    return (
        <Card.Header.Description>
            <Card.Header.Description.Title style={{ fontSize: 24 }}>
                <FontAwesomeIcon icon={faMapPin} style={{ marginRight: 16, color: "var(--wds-color-primary-700)" }} />
                Nav Point {point.id}
            </Card.Header.Description.Title>
        </Card.Header.Description>
    );
};

export const NavPointCard = ({ trigger }: Props) => {
    const point = navPoints.find((p) => p.id === trigger.pointId);
    if (!point) {
        return <div>No data found for nav point {trigger.pointId}</div>;
    }

    return (
        <div className={styles.card_info}>
            <div>
                <b>Floor:</b> {point.floorId}
            </div>
            <div>
                <b>Location:</b> x: {point.location.x}, y: {point.location.y}
            </div>
        </div>
    );
};

export const NavPointActions = ({ trigger }: Props) => {
    const { setTrigger } = useContext(InfoPopoverContext);

    const handleDelete = () => {
        if (confirm("Are you sure you want to delete this nav point?")) {
            storageService.deleteNavPoint(trigger.pointId);
            setTrigger(null);
        }
    };

    return (
        <div style={{ display: "flex", gap: 8 }}>
            <Button onClick={() => setTrigger({ type: "nav-connect", startPointId: trigger.pointId })}>
                <Button.Icon>
                    <FontAwesomeIcon icon={faLink} />
                </Button.Icon>
                <Button.Content>Connect with…</Button.Content>
            </Button>
            <Button onClick={handleDelete}>
                <Button.Icon>
                    <FontAwesomeIcon icon={faTrash} />
                </Button.Icon>
                <Button.Content>Delete</Button.Content>
            </Button>
        </div>
    );
};
